import { render, staticRenderFns } from "./DayOverview.vue?vue&type=template&id=8affecf0&scoped=true&"
import script from "./DayOverview.vue?vue&type=script&lang=ts&"
export * from "./DayOverview.vue?vue&type=script&lang=ts&"
import style0 from "./DayOverview.vue?vue&type=style&index=0&id=8affecf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8affecf0",
  null
  
)

export default component.exports